import { render, staticRenderFns } from "./ExcBaseInput.vue?vue&type=template&id=637af4cb&scoped=true&"
import script from "./ExcBaseInput.vue?vue&type=script&lang=js&"
export * from "./ExcBaseInput.vue?vue&type=script&lang=js&"
import style0 from "./ExcBaseInput.vue?vue&type=style&index=0&id=637af4cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637af4cb",
  null
  
)

export default component.exports